import React from "react";
import { Typography } from "@material-ui/core";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import ImageIcon from "@material-ui/icons/Image";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import DescriptionIcon from "@material-ui/icons/Description";
import { getFileExtension, getFileSizeString } from "@icarius-utils/fileUpload";
import { RESOURCES_ENDPOINT } from "@icarius-connection/endpoints";

const getFileIcon = (fileType) => {
    if (fileType.includes("image")) return <ImageIcon style={{ color: "var(--mainText)" }} />;
    if (fileType.includes("pdf")) return <PictureAsPdfIcon style={{ color: "var(--mainText)" }} />;
    if (fileType.includes("sheet") || fileType.includes("excel") || fileType.includes("csv")) return <DescriptionIcon style={{ color: "var(--mainText)" }} />;
    return <InsertDriveFileIcon style={{ color: "var(--mainText)" }} />;
};

const AttachmentsDisplay = ({ attachments, isUser }) => {

    if (!attachments?.length) return null;

    return (
        <div
            style={{
                margin: "8px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: 10,
            }}
        >
            {
                attachments.map((attachment, attachmentIndex) => {
                    const filePath = isUser ? URL.createObjectURL(attachment) : RESOURCES_ENDPOINT + attachment.path;

                    if (attachment.type.startsWith("image/")) {
                        return (
                            <img
                                key={attachmentIndex}
                                src={filePath}
                                alt={attachment.name}
                                onClick={() => window.open(filePath, "_blank")}
                                style={{
                                    cursor: "pointer",
                                    maxWidth: "100%",
                                    maxHeight: 200,
                                    borderRadius: 8,
                                    objectFit: "cover",
                                    display: "block",
                                }}
                            />
                        )
                    }

                    return (
                        <div
                            key={attachmentIndex}
                            title={attachment.name}
                            onClick={() => window.open(filePath, "_blank")}
                            style={{
                                cursor: "pointer",
                                borderRadius: 8,
                                background: "var(--tertiaryBackgroundColor)",
                                border: "1px solid var(--borderColor)",
                                minWidth: 180,
                                padding: "5px 10px",
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            {getFileIcon(attachment.type)}
                            <div>
                                <Typography className="whiteText" style={{ fontSize: 14, wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
                                    {attachment.name.length > 40 ? attachment.name.substring(0, 40) + "..." : attachment.name}
                                </Typography>
                                <Typography variant="caption" className="whiteText" style={{ opacity: 0.65 }}>
                                    {getFileExtension(attachment.name).toUpperCase()}{attachment.size ? `• ${getFileSizeString(attachment.size)}` : ""}
                                </Typography>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    );
};

export default AttachmentsDisplay;